export default __webpack_public_path__ + "static/media/calendarBlack.e6e663c2.svg";